import type { AppDispatch } from '@redux/store'

import useDispatch from '@hooks/useDispatch'

import * as taskListItemActions from '@redux/modules/taskListItem'

const deleteArtwork = (params: { deleteFn: () => void, redirect: string }) => {
  const { deleteFn, redirect } = params

  deleteFn().then(() => {
    if (redirect){
      window.location.href = redirect
    }
  })
}

const fetchEditorOptions = (params: { dispatch: AppDispatch, redirect: string, taskListItemId: number }) => {
  const { dispatch, redirect, taskListItemId } = params
  const { artworkBuilderConfig: loadFn } = taskListItemActions

  return dispatch(loadFn(taskListItemId)).then((response) => {
    const { data, errors, success } = response
    if (success){
      const mergedConfig = {
        ...data,
        redirectUrl: redirect,
      }

      return { success: true, data: mergedConfig }
    }

    return { success: false, errors }
  })
}

const goBack = (params: { redirect: string }) => {
  const { redirect } = params

  if (redirect){
    window.location.href = redirect
  }
}

type UseArtworkBuilderOptions = {
  redirect: string,
  taskListItemId: number,
}

function useArtworkBuilder(options: UseArtworkBuilderOptions) {
  const { redirect, taskListItemId } = options

  const dispatch = useDispatch()

  return {
    callbacks: {
      deleteArtwork: deleteFn => (
        deleteArtwork({ deleteFn, redirect })
      ),
      fetchEditorOptions: () => (
        fetchEditorOptions({ dispatch, redirect, taskListItemId })
      ),
      goBack: () => goBack({ redirect }),
    },
  }
}

export default useArtworkBuilder
